import { EQUIPMENT_LIST_COLUMNS } from "@/components/equipment/equipment-list-columns";
import { useColumnSelection } from "@/hooks/useColumnSelection";

/** Per-user selection of visible columns in the equipment list. */
export function useEquipmentListColumns() {
  return useColumnSelection("equipment-list-columns", EQUIPMENT_LIST_COLUMNS);
}
